import React from 'react';
import { Button, Box } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';
import MicrosoftIcon from '@mui/icons-material/Microsoft';
import FacebookIcon from '@mui/icons-material/Facebook';

// Provider icon mapping
const providerIcons = {
  google: GoogleIcon,
  microsoft: MicrosoftIcon,
  facebook: FacebookIcon,
};

// Provider colors
const providerColors = {
  google: {
    background: '#ffffff',
    border: '#dadce0',
    color: '#3c4043',
    hoverBackground: '#f8f9fa'
  },
  microsoft: {
    background: '#0078d4',
    border: '#0078d4',
    color: '#ffffff',
    hoverBackground: '#106ebe'
  },
  facebook: {
    background: '#ffffff',
    border: '#dadce0',
    color: '#3c4043',
    hoverBackground: '#f8f9fa'
  }
};

const OAuthButton = ({ 
  provider, 
  onClick, 
  disabled = false, 
  fullWidth = true,
  size = 'large',
  children 
}) => {
  const IconComponent = providerIcons[provider.toLowerCase()];
  const colors = providerColors[provider.toLowerCase()] || providerColors.google;
  
  const displayName = provider.charAt(0).toUpperCase() + provider.slice(1);

  return (
    <Button
      fullWidth={fullWidth}
      variant="outlined"
      size={size}
      disabled={disabled}
      startIcon={IconComponent ? <IconComponent /> : null}
      onClick={() => onClick(provider)}
      sx={{
        py: 1.5,
        borderColor: colors.border,
        backgroundColor: colors.background,
        color: colors.color,
        fontWeight: 500,
        textTransform: 'none',
        '&:hover': {
          borderColor: colors.border,
          backgroundColor: colors.hoverBackground,
        },
        '&:disabled': {
          opacity: 0.6,
          cursor: 'not-allowed'
        }
      }}
    >
      {children || `Continue with ${displayName}`}
    </Button>
  );
};

const OAuthButtonGroup = ({ 
  providers = [], 
  onProviderSelect, 
  disabled = false,
  orientation = 'vertical' // 'vertical' or 'horizontal'
}) => {
  if (!providers.length) {
    return null;
  }

  const isVertical = orientation === 'vertical';

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: isVertical ? 'column' : 'row',
        gap: isVertical ? 2 : 1,
        flexWrap: isVertical ? 'nowrap' : 'wrap'
      }}
    >
      {providers.map((provider) => (
        <OAuthButton
          key={provider.name}
          provider={provider.name}
          onClick={onProviderSelect}
          disabled={disabled}
          fullWidth={isVertical}
        />
      ))}
    </Box>
  );
};

export { OAuthButton, OAuthButtonGroup };
export default OAuthButton;
